/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

//----------------------------------------TRANSFORMATIONS------------------------------------
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';
import { getCurrentSat } from '../dataset';

// PCA
Blockly.Blocks['analyse_principal_component_analysis'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Principal Component Analysis");
        this.appendDummyInput('inp')
            .appendField("No. of PCs to visualize: ")
            .appendField(new Blockly.FieldDropdown([["2", "2"], ["3", "3"], ["4", "4"], ["5", '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10']]), 'no');
        this.setPreviousStatement(true, 'pca');
        this.setNextStatement(true, getAllowedOutputs('pca'));
        this.setInputsInline(false);
        this.setStyle('analysis');
        this.setTooltip(Blockly.Msg.PCA_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        let prev_sat = '';
        this.setOnChange(() => {
            var allowedSat = ['l8', 'l7', 'l5', 'l4', 's2'];
            if (prev_sat !== getCurrentSat(this) && prev_sat !== null && allowedSat.includes(getCurrentSat(this))) {
                this.updateShape_();
                prev_sat = getCurrentSat(this);
            }
        });
    },

    updateShape_: function () {
        let bands = [["2", "2"], ["3", "3"], ["4", "4"], ["5", '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10']];
        if (getCurrentSat(this) !== 's2') {
            bands = bands.slice(0, 5);
        }
        try {
            this.getInput('inp').removeField('no');
        } catch (e) {/**/ }
        this.getInput('inp')
            .appendField(new Blockly.FieldDropdown(bands), 'no');
    }
};